import TYPES from '../types';

export default value => {
  return {
    type: TYPES.SET_INSTRUCTOR_VIEW,
    payload: { value },
  };
};
